<template>
  <div class="user-card withdraw">
    <div class="card-header">{{ $t('withdraw') }}</div>
    <div class="content">
      <md-field>
        <div class="item-label balance-label">{{ $t('currentBalance') }}</div>
        <div class="number">
          {{ accountInfo.balance | formatMoney }}
        </div>
        <div class="item-label withdraw-label">{{ $t('withdraw') }}</div>
        <md-input-item
          title=""
          placeholder="Rp 10,000"
          ref="amount"
          name="amount"
          v-model="withdrawForm.amount"
          type="money"
          v-validate="{ required: true, min_value: minWithdraw, insufficient: accountInfo.balance, withdrawAll: accountInfo.balance }"
          :error="errors.first('amount')"
          class="input-money-container bordered withdraw-amount"
        >
          <cleave
            slot="left"
            v-model="withdrawForm.amount"
            :options="amountFormatOptions"
            class="input-money-inner"></cleave>
        </md-input-item>
        <div class="limitation-tip">
          {{ $t('tip') }}
          <a class="limitation-link" @click="showLimitation">
            {{ $t('limitRule') }}
          </a>
        </div>
        <div class="submit-button">
          <md-button type="primary" @click="submitWithdraw">
            {{ $t('withdraw') }}
          </md-button>
        </div>
      </md-field>
    </div>
    <withdraw-limitation :visible="limitationVisible" @hideDialog="limitationVisible = false"></withdraw-limitation>
    <bind-bank-dialog
      :title="$t('withdrawBindBankTitle')"
      :visible="bindBankDialogVisible"
      @hideDialog="hideBindBankDialog"
    ></bind-bank-dialog>
  </div>
</template>

<script>
import { Field, InputItem, Button, Popup } from 'mand-mobile'
import WithdrawLimitation from '@/components/user/WithdrawLimitation'
import bindBankMixin from '@/mixins/bind-bank'
import Cleave from 'vue-cleave-component'
import { amountOptions } from '@/lib/cleave'

export default {
  i18n: {
    messages: {
      en: {
        bindBankTip:
          'You do not have a bank account yet. bind your bank account first.',
        checkInfo: 'Invalid input, please check again',
        currentBalance: 'Current Balance',
        goBindBankCard: 'Bind now',
        insufficient: 'Insufficient Balance',
        minValue: 'At least {minValue}',
        withdraw: 'Withdraw',
        withdrawSuccess: 'You have applied to withdraw {currencyType} {number}.',
        withdrawPending: 'You have applied to withdraw {currencyType} {number}.We will give your result in 24 hours.',
        withdrawBindBankTitle: 'To withdraw money you have to fill out your bank account first',
        tip: 'In order to make sure you can withdraw successfully,please read',
        limitRule: 'Limitations of payment amount',
      },
      id: {
        bindBankTip:
          'Anda belum memiliki akun bank, silahkan sambungkan akun bank dahulu.',
        checkInfo: 'Masukan tidak valid, silakan periksa info Anda',
        currentBalance: 'Nominal',
        goBindBankCard: 'Ikat sekarang',
        insufficient: 'Nominal tidak mencukupi',
        minValue: 'At least {minValue}',
        withdraw: 'Penarikan Dana',
        withdrawSuccess: 'Anda telah mengajukan penarikan {currencyType} {number}.',
        withdrawPending: 'Anda telah mengajukan penarikan {currencyType} {number}. Kami akan memberikan hasilnya dalam 24 jam.',
        withdrawBindBankTitle: 'Untuk menarik nominal silahkan mengisi akun bank terlebih dahulu',
        tip: 'Untuk memastikan penarikan berhasil, silakan membaca',
        limitRule: 'Batasan jumlah penarikan',
      },
    },
  },
  components: {
    [Field.name]: Field,
    [InputItem.name]: InputItem,
    [Button.name]: Button,
    [Popup.name]: Popup,
    WithdrawLimitation,
    Cleave,
  },
  mixins: [
    bindBankMixin,
  ],
  data() {
    return {
      amountFormatOptions: amountOptions,
      withdrawForm: {
        amount: '',
      },
      showTip: false,
      limitationVisible: false,
    }
  },
  computed: {
    currencyType() {
      return this.$store.state.currency
    },
    accountInfo() {
      return this.$store.state.accountOverview.find(data => {
        return this.currencyType === data.currencyType
      })
    },
    minWithdraw() {
      return { USD: 0, IDR: 10000 }[this.currencyType]
    },
  },
  methods: {
    async submitWithdraw() {
      const result = await this.$validator.validate()
      if (!result) {
        return
      }
      try {
        const payload = {
          accountId: this.accountInfo.id,
          amount: Number.parseFloat(this.withdrawForm.amount),
          balance: this.accountInfo.balance,
        }
        this.$toast.loading('loading...')
        const response = await this.$http.post('/transaction/submit-withdraw', payload)
        if (response.data.code === 'BANK_ACCOUNT_NOT_EXIST') {
          this.bindBankDialogVisible = true
        }
        if (response.data.code === 'SUCCESS') {
          await this.$store.dispatch('reloadAccount', { force: true })
          if (response.data.data.status === 'PENDING') {
            this.$toast.succeed(this.$t('withdrawPending', {
              number: this.withdrawForm.amount,
              currencyType: this.currencyType,
            }))
          }
          if (response.data.data.status === 'TRANSFERRED') {
            this.$toast.succeed(this.$t('withdrawSuccess', {
              number: this.withdrawForm.amount,
              currencyType: this.currencyType,
            }))
          }
          this.withdrawForm.amount = ''
          this.$validator.reset()
        }
      } catch (error) {
        console.error(error)
      } finally {
        this.$toast.hide()
      }
    },
    showLimitation() {
      this.limitationVisible = true
    },
  },
}
</script>

<style lang="stylus" scoped>
.withdraw {
  position: relative;
}

.withdraw-tip {
  padding: 16px;
  font-size: 16px;
  color: #ffffff;
  background: color-primary;
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  z-index: 10;
}

.content {
  .number {
    font-size: 24px;
  }
}

.item-label {
  color: #999;
  font-size: 14px;
  margin-bottom: 10px;
}

.withdraw-label {
  margin-top: 20px;
}

.submit-button {
  margin-top: 40px;
}

.withdraw /deep/ {
  .md-field .md-field-content .md-input-item,
  .md-field .md-field-content .md-input-item.is-title-latent .md-input-item-msg {
    padding-left: 0;
    padding-right: 0;
  }
}

.withdraw-amount {
  margin-bottom: 15px;
}

.limitation-tip {
  font-size: 11px;
  line-height: 14px;
  .limitation-link {
    display: inline-block;
    color: color-primary;
    text-decoration: underline;
    cursor: pointer;
  }
}

.bind-tip {
  margin: 100px auto;
  text-align: center;
  font-size: 14px;
  color: #999;
  .bind-tip-inner {
    margin: 10px 0;
  }
}
</style>
